/* eslint-disable */
import cns from "classnames";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { USER_TYPES } from "@/config/constants";
import styles from "./header.module.scss";
import Logo from "../../logo/Logo";
import Image from "next/image";
import { IMAGE_BASE_PATH } from "@/config/config";
import { useAssistanceNumber } from "@/hooks/useAssistanceNumber";

export default function InternalHeader() {
  const router = useRouter();
  const assistanceNumber = useAssistanceNumber();

  return (
    <div className={styles.header}>
      <section className="d-flex align-items-center justify-content-between">
        <Logo handleLogoClick={() => {}} />
        <aside className={styles.navItemList}>
          <nav className="position-relative">
            <span
              className={cns(
                "font-weight-500 colorPrimary font-18",
                styles.customerSupport
              )}
            >
              <a href={`tel:${assistanceNumber}`} className={styles.phoneLink}>
                <Image
                  src={`${IMAGE_BASE_PATH}/images/phone.svg`}
                  alt="customer support"
                  width={25}
                  height={24}
                  priority
                />
                {/* 18002667780 */}
                <span className={styles.tollFreeNumber}>
                  {assistanceNumber}
                </span>
              </a>
            </span>
          </nav>
        </aside>
      </section>
    </div>
  );
}

InternalHeader.propTypes = {
  isFirstPage: PropTypes.bool,
  raiseServiceRequest: PropTypes.shape({
    show: PropTypes.bool,
    requestFor: PropTypes.string,
  }),
  showMobileInLogin: PropTypes.bool,
};

InternalHeader.defaultProps = {
  isFirstPage: false,
  raiseServiceRequest: {
    show: false,
    requestFor: "",
  },
  showMobileInLogin: true,
};
